// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"G_ct","breadcrumbs__link":"G_cv","breadcrumbs__link__active":"G_cw","breadcrumbs__span":"G_cx"};